import React, { memo } from 'react';
import * as Styles from '../../style';

interface IHeaderCharts {
  head: string;
}

const Header: React.FC<IHeaderCharts> = ({ head }) => {
  return (
    <Styles.HeaderContaienr>
      <legend>{head}</legend>
    </Styles.HeaderContaienr>
  );
};

export const HeaderCharts = memo(Header);
